import { Text } from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import LineScale from './LineScale'
import styles from './Loading.module.scss'
import LoadingPage from './LoadingPage'

const MSG = defineMessages({
  loading: {
    id: 'Loading.loading',
    defaultMessage: 'Loading...'
  }
})

export type LoadingAppProps = {
  message?: string
}

const LoadingApp = ({ message }: LoadingAppProps) => {
  return <LoadingPage message={message} />
}

export default LoadingApp
